import * as React from 'react';

import CreateFolderPopup from './CreateFolderPopup';
import DeleteDocumentPopup from './DeleteDocumentPopup';
import RemoveFolderPopup from './RemoveFolderPopup/RemoveFolderPopup';
import UploadDocumentPopup from './UploadDocumentPopup';

const Popups: React.FC = () => {
  return (
    <>
      <UploadDocumentPopup />
      <DeleteDocumentPopup />
      <CreateFolderPopup />
      <RemoveFolderPopup />
    </>
  );
};

export default React.memo(Popups);
